import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "./TermsConditions.css";

export default function TermsConditions() {

  return (

    <>

      <Navbar />

      {/* ================= HERO ================= */}
<section className="policy-hero">

    <h1>Terms & Conditions</h1>

</section>

      {/* ================= CONTENT ================= */}

      <section className="legal-content">

        <div className="legal-container">

          <h2>1. Acceptance of Terms</h2>

          <p>
            Welcome to the website of E-Forum Systems Private Limited
            ("we", "us", or "our"), accessible at
            www.eforumsystems.com (the "Website" or "Platform").
            By accessing, browsing, or using this Website and our
            associated services, you agree to be bound by these
            Terms of Use and our Privacy Policy. If you do not
            agree to these terms, please refrain from using our
            Platform.
          </p>

          <h2>2. Description of Services</h2>

          <p>
            E-Forum Systems Private Limited is a software
            development company providing IT solutions,
            web and mobile application platforms,
            and related services for both customers
            and merchant partners.
          </p>

          <p>
            We reserve the right to modify, suspend,
            or discontinue any part of the service
            at any time without prior notice.
          </p>

          <h2>3. User Obligations and Conduct</h2>

          <p>
            When using our Platform, you agree to the following:
          </p>

          <ul>

            <li>
              You will provide accurate, current and complete
              information when registering an account.
            </li>

            <li>
              You are responsible for maintaining the
              confidentiality of your account credentials.
            </li>

            <li>
              You will not use the Platform for any
              unlawful or unauthorized purpose.
            </li>

            <li>
              You will not attempt to gain unauthorized
              access to our systems, user accounts,
              or computer networks.
            </li>

            <li>
              You will not transmit any viruses,
              malware or other malicious code.
            </li>

          </ul>

          <h2>4. Intellectual Property Rights</h2>

          <p>
            All content, trademarks, logos, design,
            software and other intellectual property
            displayed on or integrated into the Platform
            are the exclusive property of
            E-Forum Systems Private Limited or its licensors.
          </p>

          <p>
            You may not reproduce, distribute,
            modify or create derivative works
            from any part of our Platform
            without our prior written consent.
          </p>
                    <h2>5. Third-Party Links and Services</h2>

          <p>
            Our Platform may contain links to third-party websites,
            applications, or services (such as payment gateways).
            We do not endorse and are not responsible for the content,
            privacy policies, or practices of any third-party websites.
          </p>

          <h2>6. Disclaimer of Warranties</h2>

          <p>
            The Platform and all services are provided on an
            "AS IS" and "AS AVAILABLE" basis.
          </p>

          <p>
            E-Forum Systems Private Limited makes no warranties,
            expressed or implied, regarding the reliability,
            accuracy, or availability of the Platform.
          </p>

          <p>
            We do not guarantee that the Platform will be
            error-free or uninterrupted.
          </p>

          <h2>7. Limitation of Liability</h2>

          <p>
            To the maximum extent permitted by applicable law,
            E-Forum Systems Private Limited shall not be liable
            for any indirect, incidental, special, consequential,
            or punitive damages, or any loss of profits or revenues,
            whether incurred directly or indirectly, resulting from
            your use of the Platform.
          </p>

          <h2>8. Indemnification</h2>

          <p>
            You agree to indemnify, defend and hold harmless
            E-Forum Systems Private Limited, its officers,
            directors, employees and agents from any claims,
            liabilities, damages, losses and expenses arising
            out of or in any way connected with your violation
            of these Terms of Use.
          </p>

          <h2>9. Termination</h2>

          <p>
            We reserve the right to suspend or terminate your
            access to the Platform at our sole discretion,
            without notice or liability, for any reason whatsoever,
            including but not limited to a breach of these
            Terms of Use.
          </p>

          <h2>10. Governing Law and Jurisdiction</h2>

          <p>
            These Terms of Use shall be governed by and construed
            in accordance with the laws of India.
          </p>

          <p>
            Any disputes arising under or in connection with
            these Terms shall be subject to the exclusive
            jurisdiction of the courts located in
            Pune/Nagpur, Maharashtra, India.
          </p>

          <h2>11. Contact Information</h2>

          <p>
            If you have any questions or concerns regarding
            these Terms of Use, please contact us at:
          </p>

          <ul>

            <li>
              <strong>Company:</strong> E-Forum Systems Private Limited
            </li>

            <li>
              <strong>Email:</strong> info@eforumsystems.com
            </li>

            <li>
              <strong>Phone:</strong> +91 8459705239
            </li>

            <li>
              <strong>Address:</strong> Pune, Maharashtra, India
            </li>

          </ul>

        </div>

      </section>

      <Footer />

    </>

  );

}
